var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ disabled: _vm.disabled, [_vm.size]: _vm.size !== '' },on:{"click":function($event){$event.stopPropagation();!_vm.disabled && _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }